import pick from 'lodash/pick';

import {FilteredBreakdownSegments, IndividualSelectedSegments} from 'common/report/constants';
import {InsightsDeprecatedLegendUrlData} from 'common/report/insights/util/types';

export class Legend {
  // deprecated
  public idxSelections: number[] | number[][];
  public otherSelections: boolean[];

  public individualSelectedSegments: IndividualSelectedSegments;
  public filteredBreakdownSegments: FilteredBreakdownSegments;

  constructor(
    attrs: {
      idxSelections?: number[] | number[][];
      otherSelections?: boolean[];
      individualSelectedSegments?: IndividualSelectedSegments;
      filteredBreakdownSegments?: FilteredBreakdownSegments;
    } = {},
  ) {
    // if the preferred individualSelectedSegments or filteredBreakdownSegments are provided, do nothing with deprecated url data
    if (attrs.individualSelectedSegments || attrs.filteredBreakdownSegments) {
      this.individualSelectedSegments = attrs.individualSelectedSegments;
      this.filteredBreakdownSegments = attrs.filteredBreakdownSegments;
    } else {
      this.idxSelections = attrs.idxSelections;
      this.otherSelections = attrs.otherSelections;
    }
  }

  serialize() {
    return {
      ...(this.individualSelectedSegments ? {individualSelectedSegments: this.individualSelectedSegments} : {}),
      ...(this.filteredBreakdownSegments ? {filteredBreakdownSegments: this.filteredBreakdownSegments} : {}),
      ...(this.idxSelections ? {idxSelections: this.idxSelections} : {}),
      ...(this.otherSelections ? {otherSelections: this.otherSelections} : {}),
    };
  }

  getDeprecatedUrlData(): InsightsDeprecatedLegendUrlData {
    return pick(this.serialize(), `idxSelections`, `otherSelections`);
  }

  toBookmarkData() {
    return pick(this.serialize(), `individualSelectedSegments`, `filteredBreakdownSegments`);
  }

  static deserialize(attrs) {
    return new Legend(attrs);
  }
}
